import React from "react";
import { CloseableAreaWrapper } from "./style";

export const CloseableArea = props => {
  return (
    <CloseableAreaWrapper
      show={props.show}
      focus={props.focus}
      onClick={event => props.onClose && props.onClose(event)}
    />
  );
};
